import { extractErrorMessageStrings } from '../utils/pipes';
import { postApi } from './ apiService';
const zenworkUrl = 'api/client/zenworks/v1/salesforce';
export const SalesForceServiceApi = {
  auth: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/auth`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  createLead: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/createLead`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
};
